import script from "./ConfirmPhonenumberModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmPhonenumberModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmPhonenumberModal.vue?vue&type=style&index=0&id=0750d131&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0750d131"]])

export default __exports__